import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/audio',
    name: 'audio',
    component: () => import('../views/AudioView.vue')
  },
  {
    path: '/spin-wheel',
    name: 'spin-wheel',
    component: () => import('../views/SpinWheelView.vue')
  },
  {
    path: '/svg',
    name: 'svg',
    component: () => import('../views/SvgView.vue')
  },
  {
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router;